<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path stroke="#000" d="M13.284 2.5L2.5 13.284l8.216 8.216L21.5 10.716l-.514-7.702-7.702-.514z"/>
  <circle cx="17.053" cy="7.118" r="1.5" stroke="#000" transform="rotate(90 17.053 7.118)"/>
</svg>
